import {useTaggingClick} from "@/hooks/common/useTagging";
import {onClickSSO} from "@COMPONENTS/common/commonUtil";
import SSOLink from "@COMPONENTS/common/ssoLink";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import * as style from "@FRAMEWORK/ui/desktop/header/NewHeader";
import useGlobalBannerText, {GlobarBannerText} from "@QUERIES/bff/global/useGlobalBannerText";
import {useEffect, useMemo, useState} from "react";

/**
 * 헤더 검색 영역
 */
const SearchArea = () => {
	const globalBannerTextFetch = useGlobalBannerText();
	const globalBannerText = globalBannerTextFetch.data?.body || [];

	const filteredBannerText = useMemo(() => globalBannerText.filter(o => o.pcYn === "Y"), [globalBannerText]);

	const [bannerText, setBannerText] = useState<GlobarBannerText>(null);
	useEffect(() => {
		if (filteredBannerText.length > 0) {
			setBannerText(filteredBannerText[Math.floor(Math.random() * filteredBannerText.length)]);
		}
	}, [filteredBannerText]);

	const {taggingClick} = useTaggingClick("pkg_search_keyword", bannerText);

	return (
		<style.SearchWrap>
			<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/common/searchGoods.yb`}>
				{bannerText?.keyword || ""}
			</SSOLink>
			<style.BtnSearch
				type="button"
				onClick={e => {
					taggingClick();
					const url = bannerText?.pcUrl || `${publicRuntimeConfig.ENV_PACKAGE_URL}/common/searchGoods.yb`;
					onClickSSO(e, url);
				}}
			>
				<span>검색</span>
			</style.BtnSearch>
		</style.SearchWrap>
	);
};

export default SearchArea;
